import React from "react";
import { Button, Tree, Upload } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { useVehicleModel } from "../vehicleModel";
import { useNavModel } from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { importPropsConfig } from "@/utils/importFile";
import { AuthButton } from "@/components/auth/AuthButton";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { ResourcesAuthBtn } from "@/types/ResourcesAuthEnum";
import { mianCode } from "@/utils/constants";
export const DataBox = () => {
    const { selectedRowKeys,
        updateEditFormVal,
        loadData,
        exportData,
        downloadTpl, resetSearchParam, setSearchParam } = useVehicleModel();

    const { addNav, findNav, selectNav, switchNavState } = useNavModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            // globalPrompt("message", { text: "请选择单条数据进行编辑", type: "warning" });
            globalPrompt("message", { text: Locale["Please select a single piece of data for editing."], type: "warning" });
            return;
        }
        let vehicleEditKey = "13-5-2-2";
        let isFindNav = findNav(vehicleEditKey);
        if (!isFindNav) {
            addNav(vehicleEditKey, { id: selectedRowKeys[0] as string, mode: "edit" });
        } else {
            globalPrompt("modal", {
                // title: "车辆跳转详情",
                title:Locale["Jump to the detail page"],
                type: "warning",
                // text: "您还有车辆详情未保存，是否跳转",
                text:Locale["The detail page has not been saved. Do you still want to jump?"],
                // okText: "跳转未保存页",
                okText: Locale["Jump to the unsaved page"],
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                // cancelText: "打开新页签",
                cancelText: Locale["Open a new page"],
                onCancel: () => {
                    switchNavState(vehicleEditKey, { id: selectedRowKeys[0] as string, mode: "edit" });
                    updateEditFormVal(null);
                }
            })
        }
    }
    const goCustomer = () => {
        addNav("13-5-1");
        setSearchParam({})
        resetSearchParam()
    }
    const action = <>
        <AuthButton
            // resCode="VehicleManagementAdd"
            resCode={ResourcesAuthBtn[mianCode]["VehicleManagementAdd"]}
            onClick={() => addNav("13-5-2-1", { id: "", mode: "add" })}
            // name="新增"
            name={Locale["Add"]}
        />
        <AuthButton
            // resCode="VehicleManagementEdit"
            resCode={ResourcesAuthBtn[mianCode]["VehicleManagementEdit"]}
            onClick={onEdit}
            // name="编辑"
            name={Locale["Edit"]}
        />
        <AuthButton
            // resCode="VehicleManagementImport"
            resCode={ResourcesAuthBtn[mianCode]["VehicleManagementImport"]}
        >
            <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig(`/vrm-sa/base/vehicle/import`, loadData)}>
                <Button className="mr-5" type="link" shape="round">{Locale["Import"]}</Button>
            </Upload>
        </AuthButton>
        <AuthButton
            // resCode="VehicleManagementDownloadTheTemplate"
            resCode={ResourcesAuthBtn[mianCode]["VehicleManagementDownloadTheTemplate"]}
            onClick={() => { downloadTpl() }}
            // name="下载模板"
            name={Locale["Download template"]}

        />
        <AuthButton
            // resCode="VehicleManagementReturningCustomers"
            resCode={ResourcesAuthBtn[mianCode]["VehicleManagementReturningCustomers"]}
            onClick={() => { goCustomer() }}
            // name="返回客户"
            name={Locale["Back to Customer"]}

        />


        {/* <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => { addNav("13-5-2-1", { id: "", mode: "add" }) }}
        >新增</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onEdit}
        >编辑</Button>
        <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig(`/vrm/base/vehicle/import`, loadData)}>
            <Button className="mr-5" type="link" shape="round">导入</Button>
        </Upload>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => { downloadTpl() }}
        >下载模板</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => goCustomer()}
        >返回客户</Button> */}
        {/* <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => { exportData() }}
        >导出</Button> */}
    </>;

    return (
        <YhBox  title={action}>
            <DataTable />
        </YhBox>
    )
}
